import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

import Scroller from 'components/Scroller'
import { BoxHeadline, SelectableItem, Flex, Avatar, Text } from 'shared/ui'
import withListController from 'components/App/DesktopView/shared/withListController'

import { propFunc } from 'util/functions'
import { withResizeChange } from 'util/hoc'

import themeVars from 'ui_theme/site/globals/site.variables'

const truncate = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const scrollerStyle = () => theme => css`
  background-color: ${theme.color.monochrome.white};
  max-height: 246px;
  border: 1px solid ${props => props.theme.color.monochrome.medium};
  border-radius: ${themeVars.defaultBorderRadius};
  margin: auto;
`

const Container = styled(Flex)`
  & > * {
    :not(:last-child) {
      margin-right: ${props => props.theme.spacing['5']};
    }
  }
  align-items: center;
  ${truncate};
`

const AgentAvatar = styled(Avatar)`
  margin-right: ${props => props.theme.spacing['7']};
  border: 2px solid white;
  border-radius: 50%;
`

const ListItem = ({
  className,
  isFocused,
  item,
  saveRef,
  onClick = null,
  /* when row/label or checkbox input clicked */
}) => {
  return (
    <SelectableItem
      className={className}
      content={
        <Container>
          <AgentAvatar size={28} actor={item} />
          <BoxHeadline truncate>{item.username}</BoxHeadline>
          <Text size="small" truncate>
            {item.name}
          </Text>
        </Container>
      }
      onContainerClick={onClick}
      selected={isFocused}
      innerRef={saveRef}
    />
  )
}

const SearchingListItem = styled(ListItem)`
  padding: ${props => props.theme.spacing['7']};
  display: block;
`

const UserList = ({ items, onSelect, focusedIndex = 0, saveItemRef }) => {
  return (
    <div>
      {items.map((item, index) => {
        return (
          <SearchingListItem
            isFocused={index === focusedIndex}
            key={item.id}
            item={item}
            onClick={propFunc(onSelect, null, item)}
            // eslint-disable-next-line react/jsx-no-bind
            saveRef={node => saveItemRef(index, node)}
          />
        )
      })}
    </div>
  )
}

class ScrollingList extends React.Component {
  componentWillUnmount() {
    this.itemRefs = null
  }

  saveItemRef = (idx, node) => {
    if (this.itemRefs && !this.itemRefs[idx]) {
      this.itemRefs[idx] = node
    }
  }

  itemRefs = []
  render() {
    const { focusedIndex } = this.props
    return (
      <Scroller
        css={scrollerStyle}
        focusedElement={this.itemRefs[focusedIndex]}
      >
        <UserList {...this.props} saveItemRef={this.saveItemRef} />
      </Scroller>
    )
  }
}

const ScrollingListWithResizingChange = withListController(
  withResizeChange(ScrollingList)
)

export default ScrollingListWithResizingChange
